var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"hmc-nav-social"},[_c('ul',{staticClass:"_pl0 hmc-nav-social__items"},_vm._l((_vm.socialList),function(item){return _c('li',{key:`fsn${item.icon.name}`,class:[
        '_d-inline-flex',
        '_mr-3',
        'hmc-nav-social__item',
        `hmc-nav-social__item--${item.icon.name}`,
      ]},[_c('a',_vm._b({staticClass:"hmc-nav-social__icon",attrs:{"href":item.href,"title":item.title,"target":"_blank","rel":"noopener noreferrer"}},'a',item.attr,false),[(item.icon.name === 'sparkle')?_c('hot-hcm-icon',{attrs:{"name":item.icon.name}}):_c('hot-hcm-icon',{attrs:{"font-awesome":['fab', item.icon.name]}})],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }